/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useRef } from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import HeaderTypography from "../components/v2/Typography/HeaderTypography";
import ParagraphTypography from "../components/v2/Typography/ParagraphTypography";
import editIcon from "../images/v4/writeToUs/icons/editIcon.svg";
import checkIcon from "../images/v4/writeToUs/icons/checkIcon.svg";

import { Link } from "gatsby";
import { makeStyles } from "@material-ui/core/styles";
import { Collapse } from "@material-ui/core";

// import singaporeSmeBannerImg from "../images/v2/campaigns/singapore-sme-banner.png";
import singaporeSmeImg from "../images/v4/writeToUs/images/blog-guest.webp";
import guidelineImg from "../images/v4/writeToUs/images/guidelineImg.webp";
import promotionImage from "../images/v4/writeToUs/images/promotionImage.webp";
import writeToUsHeroBg from "../images/v4/writeToUs/images/writeToUsHeroBg.webp";
import blogCategoryIcon1 from "../images/v4/writeToUs/icons/blogCategory1.svg";
import blogCategoryIcon2 from "../images/v4/writeToUs/icons/blogCategory2.svg";
import blogCategoryIcon3 from "../images/v4/writeToUs/icons/blogCategory3.svg";
import blogCategoryIcon4 from "../images/v4/writeToUs/icons/blogCategory4.svg";
import blogCategoryIcon5 from "../images/v4/writeToUs/icons/blogCategory5.svg";
import blogCategoryIcon6 from "../images/v4/writeToUs/icons/blogCategory6.svg";
import guidelines1 from "../images/v4/writeToUs/icons/guidelines1.svg";
import guidelines2 from "../images/v4/writeToUs/icons/guidelines2.svg";
import guidelines3 from "../images/v4/writeToUs/icons/guidelines3.svg";
import guidelines4 from "../images/v4/writeToUs/icons/guidelines4.svg";
import guidelines5 from "../images/v4/writeToUs/icons/guidelines5.svg";
import guidelines6 from "../images/v4/writeToUs/icons/guidelines6.svg";
import pepperCloudCRMHelpsBg from "../images/v2/campaigns/line-bg.svg";
import pepperCloudCRMHelpsContentBg from "../images/v2/campaigns/crm-helps-content-bg.svg";
import guestPostGuidelinesPDF from "../images/guestPostGuidelines.pdf";
import editorialBg from "../images/v4/writeToUs/images/editorialBg.webp";
import editorialImg from "../images/v4/writeToUs/images/editorialImg.webp";

import useWidth from "../hooks/useWidth";
import requestDemoBGImg from "../images/v2/campaigns/request-demo-bg.svg";
import IntegratedCRMBgImg from "../images/v2/home/integrated-crm-bg.svg";
import SEO from "../components/SEO";
import { motion } from "framer-motion";
import zIndex from "@material-ui/core/styles/zIndex";

const useStyles = makeStyles((theme) => ({
   marginAuto: {
      margin: "0 auto",
      color: "#000",
   },
   header: {
      boxShadow: "0 2px 4px 0 rgba(0,0,0,.29)",
      padding: ".65rem 0 .25rem",
   },
   singaporeSmeBanner: {
      backgroundImage: `url(${writeToUsHeroBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "1000px",
      padding: "100px 0 34vh",
      position: "relative",
      overflow: "hidden",
      [theme.breakpoints.down("md")]: {
         minHeight: "600px",
         padding: "50px 0 80px",
      },
      [theme.breakpoints.down("sm")]: {
         minHeight: "auto",
         padding: "30px 0 200px",
      },
      [theme.breakpoints.down("xs")]: {
         padding: "0px 0 20vh",
      },
      "@media (max-width: 450px)": {
         padding: "0px 0 15vh",
      }
   },
   heroBannerImg: {
      position: "absolute",
      bottom: 0,
      right: 0,
      width: "100%",
      zIndex: 0,
      pointerEvents: "none",
   },
   singaporeSmeFromBox: {
      display: "flex",
      justifyContent: "flex-end",
      [theme.breakpoints.down("sm")]: {
         justifyContent: "center",
      },
   },
   pcWebForm: {
      width: "100%",
      zIndex  : 1,
      height: "660px",
      padding:'20px',
      border: "none",
      borderRadius: "16px",
      backgroundColor: "#fff",
   },

   singaporeSmeFrom: {
      borderRadius: "16px",
      boxShadow: "0 2px 5px 0 #b7b7b7",
      maxWidth: "440px",
      backgroundSize: "430px 522px",
      backgroundColor: "#fff",
      position: "relative",
      zIndex: "1",
      padding: "30px",
      [theme.breakpoints.down("sm")]: {
         padding: "16px",
         width: "100%",
      },
   },
   singaporeSmeFromHeader: {
      background: "#2e3f4f",
      borderRadius: "16px",
      padding: ".6rem .25rem",
      letterSpacing: ".32px",
      fontSize: "24px",
      [theme.breakpoints.down("sm")]: {
         fontSize: "18px",
      },
   },
   salesProcessCard: {
      border: "none",
      boxShadow: "none",
      // backgroundColor: "transparent",
      marginBottom: theme.spacing(4),
   },
   cardHeaderAvatar: {
      height: 100,
      width: 100,
      background: "#FFF",
      boxShadow: "1px 1px 7px 0 rgb(0 0 0 / 19%)",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: -68,
   },
   colorChange: {
      color: "#ff7a59",
      fontSize: "30px",
      fontWeight: "700",
      letterSpacing: ".4px",
      [theme.breakpoints.down("sm")]: {
         fontSize: "20px",
      },
   },
   cardHeader: {
      background: "#f2f7fd",
      marginLeft: 54,
      // [theme.breakpoints.down("sm")]: {
      // 	alignItems: "end !important",
      // },
   },
   IntegratedCRMBg: {
      background: `url(${IntegratedCRMBgImg}) center bottom no-repeat`,
      backgroundSize: "cover",
   },
   whitespaceNowrap: {
      whiteSpace: "nowrap",
   },
   pepperCloudCRMHelps: {
      [theme.breakpoints.up("md")]: {
         background: `url(${pepperCloudCRMHelpsBg}) no-repeat`,
         backgroundSize: "100%",
         backgroundPosition: "center",
      },
   },
   pepperCloudCRMHelpsSpan: {
      [theme.breakpoints.up("md")]: {
         backgroundColor: "#ffffff",
         padding: "0 1rem",
      },
   },
   pepperCloudCRMHelpsContent: {
      background: `url(${pepperCloudCRMHelpsContentBg}) no-repeat`,
      backgroundSize: "cover",
      backgroundPosition: "center",
   },
   pepperCloudCRMHelpsContentListBox: {
      boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.16)",
      backgroundColor: "#ffffff",
      padding: "2rem 1rem",
   },
   pepperCloudCRMHelpsContentList: {
      listStyle: "none",
      padding: "0px",
      textAlign: "center",
      [theme.breakpoints.down("sm")]: {
         textAlign: "left",
      },
   },
   pepperCloudCRMHelpsContentListItem: {
      display: "inline-block",
      paddingRight: "1rem",
      marginRight: "1rem",
      fontSize: "20px",
      [theme.breakpoints.down("sm")]: {
         borderRight: "none !important",
      },
      "&:not(:last-of-type)": {
         borderRight: "1px solid rgba(112, 112, 112, .5)",
      },
   },
   pepperCloudCRMHelpsContentListItemSpan: {
      fontSize: "36px",
      color: "#088937",
      paddingRight: "1rem",
      lineHeight: "normal",
   },
   requestDemoRoot: {
      background: `url(${requestDemoBGImg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
   },
   commonPageFooterSection: {
      background: "linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
      padding: "80px 0",
      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "80%",
         margin: "0 auto",
         textAlign: "center",
      },
      "@media only screen and (max-width: 600px)": {
         "& .centerContainer": {
            width: "100%",
         },
      },
   },
   blogCategory: {
      marginTop: "40px",
      "@media(max-width:1024px)": {
         marginTop: "24px",
      },
   },
   categoryGrid: {
      "@media (max-width: 600px)": {
         "& > .MuiGrid-item": {
            padding: "6px 12px !important",
         },
      },
   },
   categoryCard: {
      borderRadius: "12px",
      minHeight: "260px",
      position: "relative",
      overflow: "hidden",
      cursor: "pointer",
      "&::after": {
         content: '""',
         position: "absolute",
         top: 0,
         left: 0,
         right: 0,
         bottom: 0,
         backgroundColor: "rgba(0,0,0,0)",
         transition: "background-color 0.35s ease",
         pointerEvents: "none",
         zIndex: 1,
      },
      "&:hover::after": {
         backgroundColor: "rgba(0,0,0,0.2)",
      },
      "&:hover $cardFront": {
         transform: "translateY(-110%)",
         opacity: 0,
      },
      "&:hover $cardBack": {
         transform: "translateY(0)",
         opacity: 1,
      },
      "@media (max-width: 600px)": {
         minHeight: "unset",
         overflow: "hidden",
         padding: "12px",
         display: "flex",
         flexDirection: "column",
         gap: "16px",
         cursor: "default",
         "&::after": {
            backgroundColor: "rgba(0,0,0,0.2)",
         },
         "&:hover $cardFront": {
            transform: "none !important",
            opacity: "1 !important",
         },
         "&:hover $cardBack": {
            transform: "none !important",
            opacity: "1 !important",
         },
         "& $cardFront": {
            position: "static",
            transform: "none",
            opacity: 1,
            padding: 0,
            flexDirection: "row",
            alignItems: "center",
            gap: "12px",
            justifyContent: "flex-start",
         },
         "& $cardBack": {
            position: "static",
            transform: "none",
            opacity: 1,
            padding: 0,
            gap: "10px",
         },
      },
   },
   cardFront: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      padding: "28px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      transition: "transform 0.4s ease, opacity 0.3s ease",
      transform: "translateY(0)",
      opacity: 1,
      zIndex: 2,
      "& img": {
         width: "60px",
         height: "60px",
         [theme.breakpoints.down("md")]: {
            width: "44px",
            height: "44px",
         },
         [theme.breakpoints.down("sm")]: {
            width: "40px",
            height: "40px",
         },
      },
   },
   cardBack: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      padding: "24px 28px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: "10px",
      transition: "transform 0.4s ease, opacity 0.3s ease",
      transform: "translateY(100%)",
      opacity: 0,
      zIndex: 2,
   },
   cardBackItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      color: "#fff",
      fontSize: "15px",
      lineHeight: "1.4",
      textAlign: "left",
   },
   categoryCardIconWrap: {
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      backgroundColor: "rgba(255,255,255,0.2)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
   },
   categoryCardTitle: {
      color: "#fff !important",
      fontWeight: "600 !important",
      fontSize: "18px !important",
      lineHeight: "1.4 !important",
      textAlign: "left !important",
   },
   blogCatagoryItem: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
         justifyContent: "center",
      },
   },
   blogCatagoryItemImg: {
      marginRight: "16px",
   },
   dashBorder: {
      "&:nth-of-type(1)": {
         borderRight: "2px dashed #0d6889",
         borderBottom: "2px dashed #0d6889",
      },
      "&:nth-of-type(2)": {
         borderRight: "2px dashed #0d6889",
         borderBottom: "2px dashed #0d6889",
         paddingLeft: "40px",
      },
      "&:nth-of-type(3)": {
         borderBottom: "2px dashed #0d6889",
         paddingLeft: "40px",
      },
      "&:nth-of-type(4)": {
         borderRight: "2px dashed #0d6889",
      },
      "&:nth-of-type(5)": {
         borderRight: "2px dashed #0d6889",
         paddingLeft: "40px",
      },
      "&:nth-of-type(6)": {
         paddingLeft: "40px",
      },

      "@media (max-width: 960px)": {
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         "&:nth-of-type(1)": {
            borderRight: "0 dashed #0d6889",
            borderBottom: "0 dashed #0d6889",
         },
         "&:nth-of-type(2)": {
            borderRight: "0 dashed #0d6889",
            borderBottom: "0 dashed #0d6889",
            padding: "0",
         },
         "&:nth-of-type(3)": {
            borderBottom: "0 dashed #0d6889",
            padding: "0",
         },
         "&:nth-of-type(4)": {
            borderRight: "0 dashed #0d6889",
         },
         "&:nth-of-type(5)": {
            borderRight: "0 dashed #0d6889",
            padding: "0",
         },
         "&:nth-of-type(6)": {
            padding: "0",
         },
      },
      "@media (max-width:770px)": {
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         maxWidth: "650px",
         width: "100%",
      },
   },
   writeToUsButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "85px",
      [theme.breakpoints.down("lg")]: {
         marginBottom: "65px",
      },
      [theme.breakpoints.down("md")]: {
         marginBottom: "60px",
      },
      [theme.breakpoints.down("xs")]: {
         marginBottom: "60px",
      },
   },
   promotionBox: {
      display: "flex",
      alignItems: "center",
   },
   promotionBoxContent: {
      fontSize: "18px",
      color: "#000",
      paddingLeft: "16px",
   },
   blogCategoryHeading: {
      margin: "0 0 8px",
      color: "#000",
      fontWeight: "600",
   },
   blogCathead: {
      marginBottom: "16px",
      [theme.breakpoints.down("md")]: {
         marginBottom: "12px",
      },
      color: "#000",
   },
   blogCatGrid: {
      marginBottom: "30px",
      [theme.breakpoints.down("md")]: {
         marginBottom: "18px",
      },
      [theme.breakpoints.down("sm")]: {
         marginBottom: "0px",
      },
   },
   blogCatagory: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
   },
   guidelineIcon: {
      width: 48,
      height: 48,
      borderRadius: 8,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      "& img": {
         width: 28,
         height: 28,
         filter: "brightness(0) invert(1)",
      },
   },
   guidelineCard: {
      background: "#fff",
      borderRadius: "16px",
      boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
      padding: "40px 32px",
      [theme.breakpoints.down("md")]: {
         padding: "28px 20px",
      },
      [theme.breakpoints.down("sm")]: {
         padding: "20px 16px",
      },
   },
   guidelineImg: {
      width: "100%",
      height: "auto",
      borderRadius: "12px",
      display: "block",
   },
   blogCatagoryHead: {
      margin: "0",
      fontWeight: "600",
      color: "#000",
      fontSize: "1.5rem",
      [theme.breakpoints.down("md")]: {
         fontSize: "1.375rem",
      },
      [theme.breakpoints.down("sm")]: {
         fontSize: "1.25rem",
      },
   },
   blogCatagoryContent: {
      color: "#304358",
      fontSize: "1.1rem",
      [theme.breakpoints.down("sm")]: {
         textAlign: "left",
         fontSize: "0.9375rem",
      },
   },
   guidelineColumn: {
      display: "flex",
      flexDirection: "column",
      justifyContent:'space-between',
      gap: "2rem",
      [theme.breakpoints.down("sm")]: {
         gap: "1.5rem",
      },
   },
   guestGuidlines: {
      background: "rgba(241, 223, 255, 1)",
      position: "relative",
      overflow: "hidden",
      padding: "0",
   },
   guestGuidCircle: {
      position: "absolute",
      top: "10%",
      right: "-130px",
      [theme.breakpoints.down("md")]: {
         display: "none",
      },
   },
   guestGuidDots: {
      position: "absolute",
      top: "-40%",
      left: "-130px",
      [theme.breakpoints.down("md")]: {
         display: "none",
      },
   },
   downloadBtn: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      marginTop: "10px",
      fontSize: "12px",
      [theme.breakpoints.down("md")]: {
         justifyContent: "center",
      },
      [theme.breakpoints.down("sm")]: {
         marginBottom: "16px",
      },
      p: {
         margin: "0",
      },
   },
   downloadBtnInner: {
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
      color: "#1b42dd",
      fontSize: "16px",
      cursor: "pointer",
      [theme.breakpoints.down("sm")]: {
         fontSize: "16px",
      },
   },
   catBox: {
      display: "flex",
      alignItems: "flex-start",
   },
   catBoxContent: {
      margin: "0",
      paddingLeft: "14px",
      fontSize: "16px",
      textAlign: "left",
      color: "#000",
   },
   chatBoximg: {
      marginTop: "8px",
   },
   bannerHeader: {
      color: "#000",
      marginBottom: "20px !important",
   },
   editorialProcess: {
      background: `url(${editorialBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      position: "relative",
      padding: "30px 0",
   },
   editorialInner: {
      display: "flex",
      alignItems: "center",
      gap: "48px",
      marginTop: "48px",
      [theme.breakpoints.down("sm")]: {
         flexDirection: "column",
         gap: "32px",
         marginTop: "32px",
      },
   },
   editorialImgWrap: {
      width: "50%",
      flexShrink: 0,
      [theme.breakpoints.down("sm")]: {
         width: "100%",
      },
      "& img": {
         width: "100%",
         height: "auto",
         display: "block",
      },
   },
   editorialAccordion: {
      width: "50%",
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      [theme.breakpoints.down("sm")]: {
         width: "100%",
      },
   },
   editorialItem: {
      padding: "16px",
      borderRadius: "8px",
      position: "relative",
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&::after": {
         content: '""',
         position: "absolute",
         left: 0,
         top: 0,
         width: "3px",
         height: "100%",
         background: "rgba(255,255,255,0.2)",
         borderRadius: "3px",
      },
      "&::before": {
         content: '""',
         position: "absolute",
         left: -0.5,
         top: 0,
         width: "4px",
         height: "100%",
         background:
            "linear-gradient(180deg, #B1DBFF 0%, #FF682A 100%)",
         borderRadius: "6px",
         transform: "scaleY(0)",
         transformOrigin: "top",
         zIndex: 1,
      },
      "&$editorialItemActive::before": {
         animation: "$growTimer 4s linear forwards",
      },
      "&$editorialItemActive": {},
   },
   editorialItemActive: {},
   editorialItemTitle: {
      fontSize: "1.125rem",
      fontWeight: 600,
      color: "#fff",
      margin: 0,
      opacity: 1,
      [theme.breakpoints.down("sm")]: {
         fontSize: "1rem",
      },
   },
   editorialItemDesc: {
      color: "#fff",
      fontSize: "1rem",
      lineHeight: 1.65,
      margin: "10px 0 6px",
      [theme.breakpoints.down("sm")]: {
         fontSize: "0.9375rem",
      },
   },
   "@keyframes growTimer": {
      from: { transform: "scaleY(0)" },
      to: { transform: "scaleY(1)" },
   },
   promotionBoxSection: {
    padding: "30px 0px",
      background:
         "linear-gradient(0deg,rgba(255, 255, 255, 1) 54%, rgb(250, 247, 255) 74%, rgba(241, 223, 255, 1) 100%)",
   },
   promotionList: {
      listStyle: "none",
      padding: 0,
      margin: "1.5rem 0 0",
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
   },
   promotionListItem: {
      display: "flex",
      alignItems: "flex-start",
      gap: "0.75rem",
      lineHeight: 1.6,
      [theme.breakpoints.down("sm")]: {
         fontSize: "0.9375rem",
      },
   },
   promotionBullet: {
      width: 34,
      height: 34,
      borderRadius: "50%",
      backgroundColor: "#9E5AD5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      marginBottom: 2,
   },
   promotionImgWrap: {
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
         marginTop: "2rem",
         justifyContent: "center",
      },
   },
   promotionGrid: {
      "&:nth-child(1)": {
         paddingTop: "0",
         paddingBottom: "0",
      },
      "&:nth-child(2)": {
         paddingTop: "0",
         paddingBottom: "0",
      },
   },
   catBoxImg: {
      position: "relative",
   },
   catBoxImgInner: {
      position: "absolute",
      top: "24px",
      right: "-15%",
      "@media (max-width:1500px)": {
         right: "-12%",
      },
      "@media (max-width:1400px)": {
         right: "-8%",
         height: "350px",
      },
      "@media (max-width:1380px)": {
         right: "-3%",
         height: "300px",
      },
      "@media (max-width:1280px)": {
         right: "0",
         height: "280px",
      },
      "@media (max-width:960px)": {
         position: "static",
         height: "auto",
         marginTop: "16px",
         width: "100%",
      },
   },
   catBoxIGrid: {
      alignItems: "flex-start",
   },
}));

const EDITORIAL_STEPS = [
   {
      title: "Submit your article",
      desc: "Share your guest post idea, outline, or completed draft with our editorial team for initial review. Please ensure your submission aligns with our content themes and provides meaningful value to our audience.",
   },
   {
      title: "Initial content assessment",
      desc: " Our editorial team reviews your submission for topic relevance, originality, clarity, and alignment with our audience’s interests. We focus on ensuring the content delivers insights, practical value, and a strong perspective.",
   },
   {
      title: "Review timeline",
      desc: " Each submission is carefully evaluated as part of our editorial queue. While we aim to respond as soon as possible, the review process may take up to two weeks. If you do not hear from us within this timeframe, you are welcome to explore new ideas and submit additional topics for consideration.",
   },
   {
      title: "Editorial refinement",
      desc: " To maintain consistency and quality, we retain editorial control to refine structure, tone, formatting, and clarity where necessary. Any edits made will preserve your original intent while aligning the article with our established editorial standards.",
   },
];

const AUTO_PLAY_INTERVAL = 4000;

const GuestBlog = () => {
   const [activeStep, setActiveStep] = useState(0);
   const editorialRef = useRef(null);

   useEffect(() => {
      let interval;
      const startAutoplay = () => {
         clearInterval(interval);
         interval = setInterval(() => {
            setActiveStep((prev) => (prev + 1) % EDITORIAL_STEPS.length);
         }, AUTO_PLAY_INTERVAL);
      };
      const observer = new IntersectionObserver(
         (entries) => {
            if (entries[0].isIntersecting) {
               startAutoplay();
            } else {
               clearInterval(interval);
            }
         },
         { threshold: 0.3 },
      );
      if (editorialRef.current) observer.observe(editorialRef.current);
      return () => {
         clearInterval(interval);
         if (editorialRef.current) observer.unobserve(editorialRef.current);
      };
   }, []);

  React.useEffect(() => {
    const pcIframe = document.getElementById("pc-iframe");
    pcIframe.src = pcIframe.src + window.location.search;
    if (window.location.search)
      pcIframe.src = pcIframe.src + "&page_title=" + document.title;
    else pcIframe.src = pcIframe.src + "?page_title=" + document.title;
  }, []);

   const downloadPdf = () => {
      const link = document.createElement("a");
      link.href = guestPostGuidelinesPDF;
      link.download = "Guest-Post-Guidelines.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
   };

   const classes = useStyles();

   const width = useWidth();
   return (
      <React.Fragment>
         {/* Header  */}
         <SEO
            description="Join the team of our guest writer & share your expertise on topics such as sales management, marketing, CRM, automation, startup & more, to empower our readers to boost sales"
            keywords=" Write for us,Guest blogging,CRM guest posts, sales management blog"
            title="Write for Us | Guest Post Submission | Pepper Cloud"
         />
         {/* Banner */}
         <Box className={classes.singaporeSmeBanner}>
            <div className="container">
               <Grid alignItems="flex-start" container justify="center" spacing={4}>
                  <Grid item md={7} sm={12}>
                     <Box>
                        <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }} viewport={{ once: false }}>
                        <Box alignItems="center" display="flex" mb={2} mt={{ xs: 0, sm: 0, md: 4 }}>
                           <Box
                              component="img"
                              src={editIcon}
                              mr={1}
                              style={{ width: 30, height: 30 }}
                           />
                           <ParagraphTypography
                              color="rgba(29, 111, 182, 1)"
                              fontWeight={600}
                              m={0}
                              fontSize={22}
                           >
                              Write for us
                           </ParagraphTypography>
                        </Box>
                        </motion.div>
                        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} viewport={{ once: false }}>
                        <HeaderTypography
                           component="h1"
                           className={classes.bannerHeader}
                           fontSize={{ sm: 36, xs: 34 }[width] || 64}
                           fontWeight={600}
                           lineHeight={1.15}
                           mt={0}
                           mb={2}
                           overrideClassName
                        >
                           Contribute to the <br />
                           <span
                              style={{
                                 background:
                                    "linear-gradient(90deg, #268BEB, #9E5AD5)",
                                 WebkitBackgroundClip: "text",
                                 WebkitTextFillColor: "transparent",
                                 backgroundClip: "text",
                              }}
                           >
                              Pepper Cloud blog
                           </span>
                        </HeaderTypography>
                        </motion.div>
                        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.2 }} viewport={{ once: false }}>
                        <ParagraphTypography
                           color="#000"
                           fontSize={18}
                           fontWeight={400}
                           mb={3}
                           mt={0}
                        >
                           Become a guest contributor and share your expertise
                           with a global community of B2B professionals. The
                           Pepper Cloud Blog is a trusted knowledge hub for
                           sales leaders, marketing teams, SME founders, and
                           growth-focused professionals who want practical,
                           actionable insights.
                        </ParagraphTypography>
                        </motion.div>
                     </Box>
                  </Grid>
                  <Grid item md={5} sm={12}>
                     <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.5, delay: 0.3 }} viewport={{ once: false }}>
                     <Box
                        className={classes.singaporeSmeFromBox}
                        textAlign="center"
                     >
                        <Box
                           className={classes.pcWebForm}
                           border="none"
                           component="iframe"
                           id="pc-iframe"
                           overflow="hidden"
                           referrerpolicy="unsafe-url"
                           src="https://app.peppercloud.com/form/6fdb1b2e-e739-4fd4-9710-fdee86bf1d81/embed"
                           width="100%"
                        />
                     </Box>
                     </motion.div>
                  </Grid>
               </Grid>
            </div>
            <Box
               alt="B2B Guest blogging on sales automation, sales communication, and business growth"
               className={classes.heroBannerImg}
               component="img"
               src={singaporeSmeImg}
            />
         </Box>
         {/* Content*/}
         <Box
            pb={8}
            pt={{ sm: 8, xs: 8 }[width] || 15}
            textAlign="center"
            style={{
               padding: 0,
               background:
                  "linear-gradient(180deg,rgba(255, 255, 255, 1) 54%, rgb(250, 247, 255) 74%, rgba(241, 223, 255, 1) 100%)",
            }}
         >
            <div className="container">
               <Box className={classes.marginAuto} maxWidth={960}>
                  <motion.h2
                     className="font-wix-semibold font-56 color-black1"
                     style={{ margin: "0 0 2rem" }}
                     initial={{ opacity: 0, y: 30 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5 }}
                     viewport={{ once: false }}
                  >
                     Choose a blog category
                  </motion.h2>
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.15 }} viewport={{ once: false }}>
                  <ParagraphTypography fontSize={18} color="#020D18">
                     Our audience spans multiple roles across SMEs and growing
                     businesses. Your article should align with one of the
                     categories below.
                  </ParagraphTypography>
                  </motion.div>
               </Box>
               <Box className={classes.blogCategory}>
                  <Grid container spacing={3} className={classes.categoryGrid}>
                     {[
                        {
                           title: "Sales excellence with WhatsApp and CRM",
                           bg: "#009A99",
                           blurColor: "#9B5BD4",
                           icon: blogCategoryIcon1,
                           opacity: 0.9,
                           items: [
                              "Closing deals faster with WhatsApp CRM",
                              "Managing pipelines with messaging tools",
                              "Sales automation for growing teams",
                              "WhatsApp templates for sales outreach",
                              "CRM integrations for sales teams",
                           ],
                        },
                        {
                           title: "Customer support and relationship management",
                           bg: "#2477BA",
                           blurColor: "#00BFC0",
                           icon: blogCategoryIcon2,
                           opacity: 1,
                           items: [
                              "Building long-term customer relationships",
                              "Omnichannel support strategies",
                              "CRM for customer retention",
                              "Handling customer queries via WhatsApp",
                              "Support team productivity tips",
                           ],
                        },
                        {
                           title: "WhatsApp CRM and business messaging",
                           bg: "#053A3A",
                           blurColor: "#00D4D3",
                           icon: blogCategoryIcon3,
                           opacity: 0.8,
                           items: [
                              "WhatsApp CRM best practices and strategies",
                              "Using a unified inbox for sales and support",
                              "Messaging-led sales strategies",
                              "WhatsApp Business vs WhatsApp API explained",
                              "Using social messaging platforms for SMEs",
                           ],
                        },
                        {
                           title: "AI & Automation for sales and support teams",
                           bg: "#0664EE",
                           blurColor: "#05c3c9",
                           icon: blogCategoryIcon4,
                           opacity: 0.9,
                           items: [
                              "AI chatbots for customer support",
                              "Automating follow-ups and reminders",
                              "Workflow automation for sales teams",
                              "AI-powered lead qualification",
                              "Reducing manual tasks with automation",
                           ],
                        },
                        {
                           title: "Business growth and communication",
                           bg: "#783CA8",
                           blurColor: "#ff9853",
                           icon: blogCategoryIcon5,
                           opacity: 0.7,
                           items: [
                              "Scaling SME businesses with CRM",
                              "Growth strategies for B2B teams",
                              "Business communication best practices",
                              "Building a sales-ready culture",
                              "Revenue growth through digital tools",
                           ],
                        },
                        {
                           title: "Practical use cases for WhatsApp CRM and Automation",
                           bg: "#208EEC",
                           blurColor: "#9E5AD5",
                           icon: blogCategoryIcon6,
                           opacity: 1,
                           items: [
                              "Real estate CRM use cases",
                              "Education sector WhatsApp CRM examples",
                              "E-commerce sales automation examples",
                              "Healthcare patient communication",
                              "Finance and banking CRM use cases",
                           ],
                        },
                     ].map(({ title, bg, blurColor, icon, opacity, items }, i) => (
                        <Grid item md={4} sm={6} xs={12} key={title}>
                           <motion.div
                              initial={{ opacity: 0, y: 30 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.5, delay: i * 0.1 }}
                              viewport={{ once: false }}
                           >
                           <Box
                              className={classes.categoryCard}
                              style={{ backgroundColor: bg }}
                           >
                              {/* Blur circle */}
                              <Box
                                 style={{
                                    position: "absolute",
                                    top: "-2%",
                                    left: "4%",
                                    width: "220px",
                                    height: "220px",
                                    borderRadius: "20px",
                                    backgroundColor: blurColor,
                                    opacity,
                                    filter: "blur(60px)",
                                    pointerEvents: "none",
                                    zIndex: 0,
                                 }}
                              />
                              {/* Front */}
                              <Box className={classes.cardFront}>
                                 <Box component="img" src={icon} />
                                 <ParagraphTypography
                                    className={classes.categoryCardTitle}
                                 >
                                    {title}
                                 </ParagraphTypography>
                              </Box>
                              {/* Back */}
                              <Box className={classes.cardBack}>
                                 {items.map((item) => (
                                    <Box
                                       key={item}
                                       className={classes.cardBackItem}
                                    >
                                       <Box
                                          component="img"
                                          src={checkIcon}
                                          style={{
                                             width: 20,
                                             height: 20,
                                             marginTop: 1,
                                             flexShrink: 0,
                                          }}
                                       />
                                       <span>{item}</span>
                                    </Box>
                                 ))}
                              </Box>
                           </Box>
                           </motion.div>
                        </Grid>
                     ))}
                  </Grid>
               </Box>
            </div>
         </Box>
         <Box className={classes.guestGuidlines} py={10}>
            <div className="container">
               <Box className={classes.marginAuto} maxWidth={960}>
                  <motion.h2
                     className="font-wix-semibold font-56 color-black1"
                     style={{ margin: "0 0 2rem", textAlign: "center" }}
                     initial={{ opacity: 0, y: 30 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5 }}
                     viewport={{ once: false }}
                  >
                     Guidelines for guest authors
                  </motion.h2>
               </Box>
               <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.15 }} viewport={{ once: false }}>
               <Box textAlign="center" mb={5}>
                  <ParagraphTypography fontSize={18} color="#020D18">
                     Follow the guidelines below to ensure your guest post meets
                     our writing and submission requirements.
                  </ParagraphTypography>
               </Box>
               </motion.div>
               <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: false }}>
               <Box className={classes.guidelineCard}>
                  <Grid container spacing={3} alignItems="stretch">
                     {/* Left column — 3 items */}
                     <Grid
                        item
                        md={4}
                        xs={12}
                        className={classes.guidelineColumn}
                     >
                        <Box className={classes.blogCatagory}>
                           <Box
                              className={classes.guidelineIcon}
                              style={{ backgroundColor: "#FFB54B" }}
                           >
                              <Box
                                 component={"img"}
                                 src={guidelines1}
                                 alt="Actionable insights"
                              />
                           </Box>
                           <ParagraphTypography
                              className={classes.blogCatagoryHead}
                              textAlign="left"
                           >
                              Actionable insights
                           </ParagraphTypography>
                           <ParagraphTypography
                              className={classes.blogCatagoryContent}
                              textAlign="left"
                           >
                              Go beyond theory. Explain the what, why, and
                              especially the how. End with 3–5 clear, practical
                              takeaways.
                           </ParagraphTypography>
                        </Box>
                        <Box className={classes.blogCatagory}>
                           <Box
                              className={classes.guidelineIcon}
                              style={{ backgroundColor: "#208EEC" }}
                           >
                              <Box
                                 component={"img"}
                                 src={guidelines2}
                                 alt="Expertise and originality"
                              />
                           </Box>
                           <ParagraphTypography
                              className={classes.blogCatagoryHead}
                              textAlign="left"
                           >
                              Expertise and originality
                           </ParagraphTypography>
                           <ParagraphTypography
                              className={classes.blogCatagoryContent}
                              textAlign="left"
                           >
                              Submit 100% original, unpublished, well-researched
                              content supported by data and real examples.
                           </ParagraphTypography>
                        </Box>
                        <Box className={classes.blogCatagory}>
                           <Box
                              className={classes.guidelineIcon}
                              style={{ backgroundColor: "#9E5AD5" }}
                           >
                              <Box
                                 component={"img"}
                                 src={guidelines3}
                                 alt="Quality and submission format"
                              />
                           </Box>
                           <ParagraphTypography
                              className={classes.blogCatagoryHead}
                              textAlign="left"
                           >
                              Quality and submission format
                           </ParagraphTypography>
                           <ParagraphTypography
                              className={classes.blogCatagoryContent}
                              textAlign="left"
                           >
                              Ensure error-free writing. Include a featured
                              image with attribution. Submit via Google Doc with
                              edit access, along with meta details and summary.
                           </ParagraphTypography>
                        </Box>
                     </Grid>

                     {/* Center column — image */}
                     <Grid
                        item
                        md={4}
                        sm={12}
                        xs={12}
                        style={{ display: "flex" }}
                     >
                        <Box
                           component={"img"}
                           src={guidelineImg}
                           alt="Guest author guidelines"
                           title="Guest author guidelines"
                           className={classes.guidelineImg}
                        />
                     </Grid>

                     {/* Right column — 3 items */}
                     <Grid
                        item
                        md={4}
                        xs={12}
                        className={classes.guidelineColumn}
                     >
                        <Box className={classes.blogCatagory}>
                           <Box
                              className={classes.guidelineIcon}
                              style={{ backgroundColor: "#FF8B3D" }}
                           >
                              <Box
                                 component={"img"}
                                 src={guidelines4}
                                 alt="SEO and linking"
                              />
                           </Box>
                           <ParagraphTypography
                              className={classes.blogCatagoryHead}
                              textAlign="left"
                           >
                              SEO and linking
                           </ParagraphTypography>
                           <ParagraphTypography
                              className={classes.blogCatagoryContent}
                              textAlign="left"
                           >
                              Naturally include relevant keywords and meta
                              details. Include 1–2 relevant links and 3–4
                              interlinks to our related blogs. No excessive
                              self-promotion.
                           </ParagraphTypography>
                        </Box>
                        <Box className={classes.blogCatagory}>
                           <Box
                              className={classes.guidelineIcon}
                              style={{ backgroundColor: "#009A99" }}
                           >
                              <Box
                                 component={"img"}
                                 src={guidelines5}
                                 alt="Structure and language standards"
                              />
                           </Box>
                           <ParagraphTypography
                              className={classes.blogCatagoryHead}
                              textAlign="left"
                           >
                              Structure and language standards
                           </ParagraphTypography>
                           <ParagraphTypography
                              className={classes.blogCatagoryContent}
                              textAlign="left"
                           >
                              Write in UK English. Submit up to 1500-worded
                              article supported by data and evidence.
                           </ParagraphTypography>
                        </Box>
                        <Box className={classes.blogCatagory}>
                           <Box
                              className={classes.guidelineIcon}
                              style={{ backgroundColor: "#FFB54B" }}
                           >
                              <Box
                                 component={"img"}
                                 src={guidelines6}
                                 alt="Evergreen value"
                              />
                           </Box>
                           <ParagraphTypography
                              className={classes.blogCatagoryHead}
                              textAlign="left"
                           >
                              Evergreen value
                           </ParagraphTypography>
                           <ParagraphTypography
                              className={classes.blogCatagoryContent}
                              textAlign="left"
                           >
                              Focus on timeless, high-impact topics with
                              long-term relevance, not short-term trends.
                           </ParagraphTypography>
                        </Box>
                     </Grid>
                  </Grid>
               </Box>
               </motion.div>
               <Box className={classes.downloadBtn}>
                  <Box>
                     {" "}
                     <ParagraphTypography
                        color="#43576B"
                        fontSize="14px"
                        fontFamily="'SourceSansPro-Regular', sans-serif"
                     >
                        Read detailed guidelines{" "}
                     </ParagraphTypography>
                  </Box>
                  <button
                     className={classes.downloadBtnInner}
                     onClick={downloadPdf}
                     type="button"
                     fontSize="14px"
                     style="font-family:'SourceSansPro-Regular', sans-serif"
                  >
                     here.
                  </button>
               </Box>
            </div>
         </Box>
         <Box className={classes.editorialProcess}>
            <div className="container">
               <motion.h2
                  className="font-wix-semibold font-56 font-white"
                  style={{ margin: "0 0 2rem", textAlign: "center" }}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                  viewport={{ once: false }}
               >
                  Our editorial process
               </motion.h2>
               <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.15 }} viewport={{ once: false }}>
               <ParagraphTypography
                  fontSize={18}
                  textAlign="center"
                  style={{ color: "#fff" }}
               >
                  We truly value the time and effort you invest as a guest
                  author. Our goal is to review every submission thoughtfully
                  while maintaining the quality and consistency of our content.
               </ParagraphTypography>
               </motion.div>
               <Box className={classes.editorialInner}>
                  <motion.div className={classes.editorialImgWrap} initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} viewport={{ once: false }}>
                     <Box
                        component="img"
                        src={editorialImg}
                        alt="Our editorial process"
                        title="Our editorial process"
                     />
                  </motion.div>
                  <Box
                     className={classes.editorialAccordion}
                     ref={editorialRef}
                  >
                     {EDITORIAL_STEPS.map((step, index) => (
                        <motion.div
                           key={index}
                           initial={{ opacity: 0, x: 30 }}
                           whileInView={{ opacity: 1, x: 0 }}
                           transition={{ duration: 0.5, delay: index * 0.1 }}
                           viewport={{ once: false }}
                        >
                        <Box
                           className={`${classes.editorialItem} ${
                              activeStep === index
                                 ? classes.editorialItemActive
                                 : ""
                           }`}
                           onClick={() => setActiveStep(index)}
                        >
                           <Box
                              display="flex"
                              alignItems="center"
                              style={{ gap: 12 }}
                           >
                              <Box
                                 style={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: "50%",
                                    backgroundColor: ["#FF682A", "#009A99", "#208EEC", "#9E5AD5"][index],
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                 }}
                              >
                                 <span
                                    style={{
                                       color: "#fff",
                                       fontWeight: 700,
                                       fontSize: 14,
                                    }}
                                 >
                                    {index + 1}
                                 </span>
                              </Box>
                              <Box
                                 component="h3"
                                 className={classes.editorialItemTitle}
                                 m={0}
                              >
                                 {step.title}
                              </Box>
                           </Box>
                           <Collapse in={activeStep === index}>
                              <Box className={classes.editorialItemDesc}>
                                 {step.desc}
                              </Box>
                           </Collapse>
                        </Box>
                        </motion.div>
                     ))}
                  </Box>
               </Box>
            </div>
         </Box>
         <Box className={classes.promotionBoxSection} py={10}>
            <div className="container">
               <Box className={classes.marginAuto} maxWidth={960}>
                  <motion.h2
                     className="font-wix-semibold font-56 color-black1"
                     style={{ margin: "0 0 2rem", textAlign: "center" }}
                     initial={{ opacity: 0, y: 30 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.5 }}
                     viewport={{ once: false }}
                  >
                     Promotion and distribution
                  </motion.h2>
               </Box>
               <Grid container alignItems="center" spacing={4}>
                  <Grid item md={6} sm={12} xs={12}>
                     <motion.div initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6 }} viewport={{ once: false }}>
                     <ParagraphTypography fontSize={18} color="#020D18" mb={0}>
                        Publishing your article is just the beginning. At Pepper
                        Cloud, we actively promote every approved guest post
                        across our official channels to ensure it reaches sales
                        leaders, marketing professionals, and SME
                        decision-makers worldwide.
                     </ParagraphTypography>
                     <ParagraphTypography
                        fontSize={18}
                        color="#020D18"
                        mt={5}
                        mb={5}
                     >
                        Here's how you can effectively promote your published
                        article:
                     </ParagraphTypography>
                     <Box component="ul" className={classes.promotionList}>
                        {[
                           "Share on your personal social media profiles.",
                           "Promote on your brand's official social media platforms.",
                           "Share the blog link with your existing subscribers through the newsletter.",
                           "Link the published blog with other relevant blogs you have authored.",
                           "Share it among your network of industry experts.",
                        ].map((item, i) => (
                           <motion.li
                              key={item}
                              className={classes.promotionListItem}
                              initial={{ opacity: 0, x: -20 }}
                              whileInView={{ opacity: 1, x: 0 }}
                              transition={{ duration: 0.4, delay: i * 0.08 }}
                              viewport={{ once: false }}
                           >
                              <Box className={classes.promotionBullet}>
                                 <svg
                                    width="10"
                                    height="14"
                                    viewBox="0 0 10 16"
                                    fill="none"
                                 >
                                    <path
                                       d="M2 2l6 6-6 6"
                                       stroke="#fff"
                                       strokeWidth="2.5"
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                    />
                                 </svg>
                              </Box>
                              <ParagraphTypography color="#000" marginTop="3px">
                                 {item}
                              </ParagraphTypography>
                           </motion.li>
                        ))}
                     </Box>
                     <ParagraphTypography fontSize={13} color="#0D1F31" mt={5}>
                        *Maintain attribution and use REL: CANONICAL when
                        cross-posting.
                     </ParagraphTypography>
                     </motion.div>
                  </Grid>
                  <Grid item md={6} sm={12} xs={12}>
                     <motion.div className={classes.promotionImgWrap} initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.6, delay: 0.1 }} viewport={{ once: false }}>
                        <Box
                           component="img"
                           src={promotionImage}
                           alt="Promotion and distribution"
                           title="Promotion and distribution"
                           style={{
                              width: "100%",
                              height: "auto",
                              maxWidth: 480,
                           }}
                        />
                     </motion.div>
                  </Grid>
               </Grid>
            </div>
         </Box>
         {/* Footer CTA */}
         <section className={classes.commonPageFooterSection}>
            <div className="container">
               <div className="centerContainer">
                  <motion.h2 className="font-wix-medium font-56 font-white" style={{ margin: 0 }} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} viewport={{ once: false }}>
                     Join our happy customers and increase your revenue
                  </motion.h2>
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.2 }} viewport={{ once: false }}>
                  <Link
                     className="primaryButton font-20 font-wix-medium font-white"
                     to="/contact/?utm_source=Write+for+Us&utm_medium=Book+free+demo"
                  >
                     Book free demo
                  </Link>
                  </motion.div>
               </div>
            </div>
         </section>
         {/* footer */}
      </React.Fragment>
   );
};

export default GuestBlog;
